// The unclaimed school page, ported from Unclaimed Portal.dc.html tab 1
// (page + claim CTA only per the handoff; the OTP claim flow and the nudge
// email are Ship E/F). Renders for schools.status = 'unclaimed': deliberately
// GREY header (no chosen brand to wear), the not-set-up disclaimer, typical
// requirements carrying the not-confirmed pill, the quote door into the
// normal portal flow, and the claim card linking to signup with the slug
// prefilled.
import Footer from '@/components/Footer.jsx';

const money = (v) => `$${Number(v || 0).toLocaleString('en-US')}`;
const monogram = (name) => String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');

export default function UnclaimedPortal({ school, onGetQuote }) {
  const req = school.requirements || {};
  const rows = [
    ['Liability, each occurrence / per passenger', req.liability
      ? `${money(req.liability.limit)}${req.liability.excluding_passengers ? ' excl. pax' : ` / ${money(req.liability.pax_sublimit)}`}` : ''],
    ['Damage to the rented aircraft', money(req.damage_limit?.limit)],
    ...(Number(req.deductible_reimb?.limit) > 0 ? [['Deductible reimbursement', money(req.deductible_reimb.limit)]] : []),
  ];

  return (
    <div className="mx-auto min-h-screen max-w-[560px] pb-[60px] pt-5">
      <div className="overflow-hidden rounded-[18px] border border-line bg-paper shadow-[0_20px_50px_rgba(15,23,42,0.10)]">
        <div className="bg-slate p-[20px_22px] text-white">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 flex-none items-center justify-center rounded-[11px] border border-dashed border-white/40 bg-white/15 text-[15px] font-bold text-line-strong">{monogram(school.name)}</div>
            <div className="min-w-0">
              <div className="text-[17px] font-bold">{school.name}</div>
              <div className="mt-0.5 text-[11.5px] text-line-strong">{school.home_airport ? `${school.home_airport} · ` : ''}{school.slug}.clearedto.rent</div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-warn-line bg-warn-bg p-[11px_22px] text-[12.5px] leading-[1.5] text-warn-deep">
          <span><b>Not yet set up by this school.</b> This page was created from public listings so pilots who rent here
          have somewhere to get covered. {school.name} hasn&apos;t chosen or endorsed anything.</span>
          <a href={`https://clearedto.rent/signup?slug=${encodeURIComponent(school.slug)}`}
            className="flex-none rounded-[9px] bg-accent px-3.5 py-2 text-[12px] font-bold text-white hover:bg-accent-hover">
            Are you {school.name}? Claim this page
          </a>
        </div>
        <div className="p-[22px]">
          <h1 className="mb-1.5 text-[21px] font-bold tracking-[-0.02em]">Renting here? Get covered.</h1>
          <p className="mb-4 text-[13.5px] leading-[1.55] text-ink-dim">
            You can buy your own renter insurance right now. It&apos;s your policy either way; if this school later
            sets its own requirements, we&apos;ll tell you if anything changes.
          </p>
          <div className="mb-3.5 overflow-hidden rounded-card-lg border-[1.5px] border-line-strong bg-white">
            <div className="flex items-center justify-between gap-2.5 bg-fill p-[11px_16px]">
              <span className="text-[13px] font-bold text-ink-soft">Typical school requirements</span>
              <span className="flex-none rounded-pill border border-warn-line bg-white px-[9px] py-1 text-[10px] font-bold uppercase tracking-[0.04em] text-warn-deep">Not yet confirmed by this school</span>
            </div>
            <div className="p-[4px_16px_8px] text-[13px]">
              {rows.map(([k, v]) => (
                <div key={k} className="flex justify-between border-b border-fill py-[9px] last:border-0">
                  <span className="text-ink-dim">{k}</span><b>{v}</b>
                </div>
              ))}
            </div>
          </div>
          <button type="button" onClick={onGetQuote}
            className="block w-full rounded-card-lg bg-primary p-[15px] text-center text-[15px] font-bold text-white hover:bg-primary-deep">
            Get my quote →
          </button>
        </div>
        <div className="mx-[22px] border-t border-line" />
        <div className="p-[18px_22px_22px]">
          <div className="flex flex-wrap items-center justify-between gap-3.5 rounded-card-lg border-[1.5px] border-teal-line bg-white p-[15px_17px]">
            <div className="min-w-0">
              <div className="text-[13.5px] font-bold">Are you {school.name}?</div>
              <div className="mt-0.5 text-xs leading-[1.5] text-ink-dim">
                Claim this page free: set your real requirements, see who&apos;s cleared to rent, get your poster &amp; QR.
              </div>
            </div>
            <a href={`https://clearedto.rent/signup?slug=${encodeURIComponent(school.slug)}`}
              className="flex-none rounded-[9px] bg-accent px-[18px] py-[11px] text-[13px] font-bold text-white hover:bg-accent-hover">
              Claim this page
            </a>
          </div>
          <div className="mt-3.5 text-[10px] leading-[1.6] text-ink-faint">
            Coverage by Global Aerospace · Arranged by NDEMNIFLY Aviation Insurance, CA License #6018700. This page
            lists {school.name} from public records and implies no affiliation or endorsement. School staff:{' '}
            <a className="text-ink-faint underline" href={`mailto:support@ndemnifly.com?subject=Remove%20${encodeURIComponent(school.slug)}.clearedto.rent`}>remove this page</a>.
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
